<template>
  <div class="verification-form-check-list">
    <div class="verification-cdd-form__wrp app-key-value__list">
      <div class="verification-cdd-form__questions-list">
        <h3 class="verification-cdd-form__title">
          {{ "verification-form-check-list.title" | globalize }}
        </h3>

        <div class="verification-cdd-form__question-wrp">
          <verification-form-question
            v-model="form.qus03"
            @input="former.setAttr('checkList.qus03', form.qus03)"
            :question-message="
              'verification-form-check-list.qus-03' | globalize"
            :error-message="getFieldErrorMessage('form.qus03')"
            :disabled="isDisabled"
          >
            <p>
              {{ 'verification-form-check-list.lbl-description' | globalize }}
            </p>
          </verification-form-question>
          <input-field
            v-if="CB_VALUES.yes === form.qus03"
            v-model="form.description"
            @input="former.setAttr('checkList.description', form.description)"
            :error-message="getFieldErrorMessage('form.description')"
            :label="'verification-form-check-list.lbl-qus-03' | globalize"
            :disabled="isDisabled"
          />
        </div>

        <div class="verification-cdd-form__question-wrp">
          <verification-form-question
            v-model="form.qus04"
            @input="former.setAttr('checkList.qus04', form.qus04)"
            :question-message="
              'verification-form-check-list.qus-04' | globalize"
            :error-message="getFieldErrorMessage('form.qus04')"
            :disabled="isDisabled"
          >
            <p>
              {{ 'verification-form-check-list.lbl-risk-factors' | globalize }}
              <a href="https://docs.google.com/document/d/1TKMOAvA0RV9EyfJ4LHhbO13tiXCwzpAjXpvZQJQ1Ltw/edit">
                {{ 'verification-form-check-list.lbl-link' | globalize }}
              </a>
            </p>
          </verification-form-question>
          <input-field
            v-if="CB_VALUES.yes === form.qus04"
            v-model="form.riskFactors"
            @input="former.setAttr('checkList.riskFactors', form.riskFactors)"
            :error-message="getFieldErrorMessage('form.riskFactors')"
            :label="'verification-form-check-list.lbl-qus-04' | globalize"
            :disabled="isDisabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VerificationFormQuestion from './VerificationFormQuestion'

import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import { UserRecord } from '@/js/records/entities/user.record'
import { required } from '@validators'

import FormMixin from '@/vue/mixins/form.mixin'

const CB_VALUES = {
  yes: 'Yes',
  no: 'No',
}

export default {
  name: 'verification-form-check-list',
  components: { VerificationFormQuestion },
  mixins: [ FormMixin ],
  props: {
    former: {
      type: [VerificationCDDFormer, VerificationBDDFormer],
      required: true,
    },
    userDetails: {
      type: UserRecord,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      CB_VALUES,
      form: {
        qus03: this.former.attrs.checkList.qus03,
        qus04: this.former.attrs.checkList.qus04,
        description: this.former.attrs.checkList.description,
        riskFactors: this.former.attrs.checkList.riskFactors,
      },
    }
  },
  validations () {
    let form = {
      qus03: { required },
      qus04: { required },
    }

    if (this.form.qus03 === CB_VALUES.yes) {
      form.description = { required }
    }
    if (this.form.qus04 === CB_VALUES.yes) {
      form.riskFactors = { required }
    }

    return { form }
  },
}
</script>
